import type { Router } from 'vue-router'
import verifyLoginGuard from '@/router/guard/verify-login'
import setPageTitleGuard from '@/router/guard/page-title'
// import verifyPermissionGuard from '@/router/guard/verify-permission'

export default function registerRouterGuard(router: Router) {
  setPageTitleGuard(router)
  verifyLoginGuard(router)
  // verifyPermissionGuard(router)
}
